import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Straighten = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages straighten">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:straightenTitle1')}</h2>
          <p className="text">
            {t('contents:straightenParagraph1')}
            <br />
            {t('contents:straightenParagraph2')}
            <br />
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/straighten/straighten_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:straightenParagraph3')}
                <br />
                {t('contents:straightenParagraph4')}
                <br />
                {t('contents:straightenParagraph5')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/straighten/straighten_05.png')}
              />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:straightenTitle2')}</h2>
              <p>
                {t('contents:straightenParagraph6')}
                <br />
                <br />
                {t('contents:straightenParagraph7')}
                <br />
                {t('contents:straightenParagraph8')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/straighten/straighten_06.png')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:straightenTitle5')}</h2>
              <p>
                {t('contents:straightenParagraph19')}
                <br />
                {t('contents:straightenParagraph20')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/straighten/straighten_07.png')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:straightenTitle3')}</h2>
              <p>
                {t('contents:straightenParagraph9')}
                <br />
                {t('contents:straightenParagraph10')}
                <br />
                {t('contents:straightenParagraph11')}
                <br />
                {t('contents:straightenParagraph12')}
                <br />
                {t('contents:straightenParagraph13')}
                <br />
                <br />
                {t('contents:straightenParagraph14')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/straighten/straighten_08.png')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:straightenTitle6')}</h2>
              <p>
                {t('contents:straightenParagraph21')}
                <br />
                {t('contents:straightenParagraph22')}
                <br />
                {t('contents:straightenParagraph23')}
                <br />
                {t('contents:straightenParagraph24')}
                <br />
                {t('contents:straightenParagraph25')}
                <br />
                {t('contents:straightenParagraph26')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/straighten/straighten_09.png')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Straighten;
